import { createSlice } from '@reduxjs/toolkit';

export const clientContactSlice = createSlice({
    name: "clientContact",
    initialState: [],
    reducers: {
        set: (state, action) => {
            state = action.payload;
            return state;
        }
    }
})

export const clientContactActions = clientContactSlice.actions;

export default clientContactSlice.reducer;